var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__a",
    width: 26,
    height: 26,
    x: 0,
    y: 0,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__b",
    width: 26,
    height: 24,
    x: 0,
    y: 0,
    rx: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#BABFCD",
    opacity: 0.4,
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F4FA",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#949CAF",
    fillRule: "nonzero",
    d: "M13.742 17.14c1.554 0 2.898-.658 3.752-1.778l-1.148-.91c-.658.84-1.526 1.26-2.604 1.26-.952 0-1.75-.336-2.408-1.022-.658-.686-.98-1.512-.98-2.492s.322-1.806.98-2.492c.658-.686 1.456-1.036 2.408-1.036 1.008 0 1.862.406 2.576 1.204l1.148-.896c-.882-1.078-2.212-1.736-3.724-1.736-1.358 0-2.52.49-3.458 1.456-.938.966-1.414 2.128-1.414 3.5 0 1.372.476 2.534 1.414 3.5.938.966 2.1 1.442 3.458 1.442z",
    mask: "url(#prefix__c)",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.88f3eed0.svg";
export { ForwardRef as ReactComponent };